export default "__VITE_ASSET__DeM4TLcL__"